// extracted by mini-css-extract-plugin
export default {"documentsWrapper":"documents_documentsWrapper__jjRWS"};